var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "22px",
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prescription") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tools",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tools---activity-reports-expanded",
    transform: "translate(-35.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prescription",
    transform: "translate(-71.000000, 81.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4987773,4.717625 L11.8781667,0.134277344 C11.7915305,0.0483398438 11.6742251,0 11.5514616,0 L1.8482096,0 C0.828891641,0 0,0.822207031 0,1.83334766 L0,20.1666953 C0,21.177793 0.828891641,22 1.84825292,22 L14.7859367,22 C15.8052547,22 16.6341463,21.177793 16.6341463,20.1666523 L16.6341463,5.04165234 C16.6341463,4.91992188 16.5854135,4.8035625 16.4987773,4.717625 Z M12.0135357,1.56479297 L15.0566315,4.58334766 L12.9376405,4.58334766 C12.4282198,4.58334766 12.0135357,4.17200781 12.0135357,3.66669531 L12.0135357,1.56479297 L12.0135357,1.56479297 Z M15.7100415,20.1666523 C15.7100415,20.6719648 15.2953575,21.0833047 14.7859367,21.0833047 L1.84825292,21.0833047 C1.33883219,21.0833047 0.92414812,20.6719648 0.92414812,20.1666523 L0.92414812,1.83334766 C0.92414812,1.32803516 1.33883219,0.916695312 1.84825292,0.916695312 L11.0894309,0.916695312 L11.0894309,3.66669531 C11.0894309,4.67779297 11.9183225,5.5 12.9376838,5.5 L15.7100415,5.5 L15.7100415,20.1666523 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1653487,12.9758506 C11.9626972,12.8221261 11.6678754,12.8535669 11.5051028,13.045733 L10.1211833,14.6933145 L7.98110624,11.8399157 C8.87873257,11.5255496 9.52436505,10.7105204 9.52436505,9.74797097 C9.52436505,8.51524031 8.47118477,7.51219512 7.17683868,7.51219512 L5.29879117,7.51219512 C5.03927051,7.51219512 4.82926829,7.7122005 4.82926829,7.95936706 L4.82926829,14.2195646 C4.82926829,14.4667312 5.03927051,14.6667365 5.29879117,14.6667365 C5.55831183,14.6667365 5.76831405,14.4667312 5.76831405,14.2195646 L5.76831405,11.9837887 L6.93536474,11.9837887 L9.51168832,15.4189261 L7.74905181,17.5172847 C7.58720352,17.7102893 7.62021582,17.9915377 7.82242714,18.1461006 C7.90909542,18.2120424 8.01271001,18.2439024 8.11540026,18.2439024 C8.25339165,18.2439024 8.38957838,18.186261 8.48267305,18.0762182 L10.0792357,16.1755174 L11.4900052,18.0565572 C11.5816913,18.178841 11.725669,18.2439024 11.8724196,18.2439024 C11.9668788,18.2439024 12.0622623,18.2168214 12.1447931,18.1604795 C12.3557196,18.0172353 12.4047539,17.7377895 12.2539097,17.5369038 L10.6887307,15.4499477 L12.238724,13.6046665 C12.4005723,13.4116619 12.36756,13.1304555 12.1653487,12.9758506 Z M5.76831405,11.0894029 L5.76831405,8.40645516 L7.17683868,8.40645516 C7.95355197,8.40645516 8.5853633,9.00819004 8.5853633,9.74792905 C8.5853633,10.4876681 7.95355197,11.0894029 7.17683868,11.0894029 L5.76831405,11.0894029 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDins);
export default __webpack_public_path__ + "static/media/dins.7d613fa135434e3361c2cc2303a6f424.svg";
export { ForwardRef as ReactComponent };